import styled from 'styled-components'

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: 14px;
    max-height: 320px;
    overflow-y: auto;
  }
  .rankmiTable-rowsCount {
    display: none !important;
  }
  > button {
    background-color: #e7f3fe !important;
    box-shadow: none;
    border: none;
    border-radius: 8px;
    padding: 0 8px;
    margin-top: 24px;
    font-weight: 700;
    color: #0085ff !important;
    svg {
      margin-right: 5px;
    }
    &:hover {
      opacity: 0.7;
    }
    &:disabled {
      opacity: 0.48;
    }
  }
`
